import { useMemo } from 'react';
import { useFlag } from 'services/flags/hooks';
import Yup from 'utils/validation';
import { useFieldValidation } from 'hooks/useFieldValidation';
import { Flags } from 'services/flags/constants';

export const useExternalIdAndJobDescription = ({
  jobDescriptionText,
  externalId
}: {
  jobDescriptionText: string;
  externalId?: string | null;
}) => {
  const isExternalIdRequiredFlag = useFlag(Flags.EXTERNAL_ID_IS_MANDATORY);

  const validationSchema = useMemo(() => {
    return Yup.object({
      jobDescription: Yup.string().required('Enter a job description'),
      externalId: isExternalIdRequiredFlag
        ? Yup.string().trim().required('Enter an external ID')
        : Yup.string().trim().optional()
    });
  }, [isExternalIdRequiredFlag]);

  type FormData = Yup.InferType<typeof validationSchema>;

  const { errors, validateAllFields, handleFieldChange } =
    useFieldValidation<FormData>(validationSchema);

  const handleValidation = (): boolean => {
    const values: FormData = {
      jobDescription: jobDescriptionText || '',
      externalId: externalId ?? undefined
    };

    return validateAllFields(values);
  };

  return {
    errors,
    handleFieldChange,
    handleValidation
  };
};
